import { useEffect, useState } from 'react';
import { EventAPI } from '../../../api/EventAPI.js';
import styles from '../../../styles/modules/ChildProfile.module.css';
import Loader from '../../../component/Loader.jsx';
import { useSelector } from 'react-redux';
import { Privileges } from '../../../util/PrivilegeConstants.js';
import { isClubOwner, isClubStaff } from '../../../util/UserRoles.js';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import PlayerFeeHistoryBody from './PlayerFeeHistoryBody.jsx';

const PlayerFeeHistory = ({ eventId, playerId, isPlayer }) => {
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const userInfo = useSelector((store) => store.user.userInfo);
    const [isLoading, setIsLoading] = useState(false)
    const [feeHistory, setFeeHistory] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState({ offline_payment: [], online_payment: [] });
    const [privileges, setPrivileges] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);

    const findPlayerFeeHistory = async () => {
        try {
            const response = await EventAPI.getEventPlayerFeesHistory(playerId, eventId);
            setFeeHistory(response.Data);
        } catch (error) {
            console.log(error);
        }
    };
    const findAllPrivileges = async () => {
        try {
            setIsLoading(true);
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[13]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const getEventPaymentMethods = async () => {
        try {
            const response = await EventAPI.getEventPaymentMethods(eventId);
            setPaymentMethods({
                online_payment: response.Data.onlinePaymentMethods,
                offline_payment: response.Data.offlinePaymentMethods
            });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        findPlayerFeeHistory();
        findAllPrivileges();
        getEventPaymentMethods();
    }, []);

    useEffect(() => {
        findPlayerFeeHistory();
        isUpdate && setIsUpdate(false)
    }, [isUpdate]);






    return (
        <div className={styles['child_guardian_container']}>
            {isLoading && <Loader />}
            <table className={styles['child_guardian_table']}>
                <thead>
                    <tr>
                        <th align='left'>Transaction ID</th>
                        <th align='left'>Fee Details</th>
                        <th align='left'>Status</th>
                        <th align='left'>Gross Amount</th>
                        <th align='left'>Net Amount</th>
                        <th align='left'>Processing Fee</th>
                        <th align='left'>Refunded Amount</th>
                        {(isClubOwner(userInfo) || isClubStaff(userInfo)) && <th align='center'>Action</th>}
                    </tr>
                </thead>
                <tbody>
                    {feeHistory?.map((fee) =>
                        <PlayerFeeHistoryBody
                            eventId={eventId}
                            isPlayer={isPlayer}
                            feeHistory={feeHistory}
                            setFeeHistory={setFeeHistory}
                            selectedClub={selectedClub}
                            setIsUpdate={setIsUpdate}
                            setIsLoading={setIsLoading}
                            fee={fee}
                            privileges={privileges}
                            userInfo={userInfo}
                            playerId={playerId}
                            offlinePaymentMethod={paymentMethods.offline_payment}
                        />
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default PlayerFeeHistory